module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./src/test.json
 ** module id = 2055
 ** module chunks = 0
 **/